<template>
  <div>
    <el-table
      class="coin-table"
      :data="addressList"
      :row-key="() => Math.random()"
      style="width: 100%"
    >
      <el-table-column label="用户Id" prop="userId"></el-table-column>
      <el-table-column label="币种类型" prop="coinType" width="150"></el-table-column>
      <el-table-column label="网络" prop="chainName" width="100"></el-table-column>
      <el-table-column label="提现地址" prop="address"></el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">有效</template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{scope.row.createTime | moment}}</template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import Pagination from "components/pagination";

export default {
  name: "withdrawAddressList",
  data() {
    return {
      sortable: ".coin-table"
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapState("userWithdrawAddress", ["addressList", "pagination", "totalCount"])
  },
  methods: {
    ...mapActions("userWithdrawAddress", ["list", "create"]),
    handlePageChanged(pagination) {
      this.$emit("refresh", { pagination });
    }
  }
};
</script>

<style lang="less" scoped>
.conf-table {
  margin-top: 20px;
}
.confirm-btn {
  margin-top: 10px;
}
</style>
